// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"70ffdfd1","453":"4907ee85","455":"7ce26e4e","977":"e189ebed"}[chunkId] + ".chunk.js";
};